import SceneManager from './SceneManager';


export default container => {
    const canvas = createCanvas(document, container);
    window.sceneManager = new SceneManager(canvas);

    let canvasHalfWidth;
    let canvasHalfHeight;

    let mouseX = 0;
    let mouseY = 0;

    let motionX = 0;
    let motionY = 0;

    bindEventListeners();
    render();

    function createCanvas(document, container) {
        const canvas = document.createElement('canvas');
        container.appendChild(canvas);
        return canvas;
    }

    function bindEventListeners() {
        window.onresize = resizeCanvas;
        resizeCanvas();

        window.onmousemove = onDocumentMouseMove;

        if (window.DeviceMotionEvent){
            window.addEventListener("devicemotion", motion, false);
        }
        else{
            console.log("DeviceMotionEvent is not supported");
        }
    }

    function motion(event){
        motionX = event.accelerationIncludingGravity.x / 4;
        motionY = event.accelerationIncludingGravity.x / 4;
    }

    function resizeCanvas() {
        canvas.style.width = '100%';
        canvas.style.height= '100%';

        canvas.width  = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        canvasHalfWidth = Math.round(canvas.offsetWidth/2);
        canvasHalfHeight = Math.round(canvas.offsetHeight/2);

        window.sceneManager.onWindowResize()
    }

    function onDocumentMouseMove( event ) {
        mouseX = (event.clientX - (window.innerWidth / 2)) / 15;
        mouseY = (event.clientY - (window.innerHeight / 2)) / 15;
    }

    function render(time) {
        requestAnimationFrame(render);

        if (window.innerWidth < 770) {
            window.sceneManager.update(motionX, motionY);
        }
        else {
            window.sceneManager.update(mouseX, mouseY);
        }
    }
}